var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 124.94,
    viewBox: "0 0 120 124.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#0090ff;}.a{opacity:0;}.c,.e{fill:#3eaaf3;}.c,.d,.g,.i{fill-rule:evenodd;}.d{fill:#0073c8;}.f,.i{fill:#323232;}.g{fill:#0290ff;}.h{fill:#63c0ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.25 16)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 120,
    height: 124.94,
    transform: "translate(-7.25 -16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 35,
    height: 71,
    transform: "translate(71 19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M86,0l20,19H51V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M30,19,51,0,71,19V90H30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M88,35v7H79V35Zm10,0v7H89V35ZM88,27v7H79V27Zm10,0v7H89V27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 14,
    height: 14,
    transform: "translate(43 27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 15,
    height: 30,
    transform: "translate(81 60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 7,
    height: 43,
    transform: "translate(47 47)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M23,0A23,23,0,0,1,46,22.62L46,23H23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M23-23A23,23,0,0,0,46-45.62L46-46H23Z",
    transform: "translate(0 69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M0,0A23,23,0,0,0,23-22.62L23-23H0Z",
    transform: "translate(23) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,23A23,23,0,0,1,23,45.62L23,46H0Z",
    transform: "translate(23 69) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 16.185,
    cy: 16.185,
    r: 16.185,
    transform: "translate(6.815 6.815)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M23.658,30.667V29.31a3.323,3.323,0,0,0,2.785-3.4c0-3.93-4.9-4.054-4.9-5.992,0-.564.388-.916,1.04-.916.723,0,1.093.405,1.093,1.216h2.573a3.276,3.276,0,0,0-2.591-3.525V15.333H21.543V16.69a3.09,3.09,0,0,0-2.538,3.155c0,3.754,4.829,4,4.829,6.045A1.08,1.08,0,0,1,22.6,26.983c-.793,0-1.287-.423-1.287-1.41H18.741a3.446,3.446,0,0,0,2.8,3.754v1.339Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/house-icon.ac6cb0924809684ed8f75f53743d80f6.svg";
export { ForwardRef as ReactComponent };